import type { AdminMcpTokenCreated, AdminMcpTokenList } from "@storyline/shared";
import { unwrap } from "@/src/common/services/api-error";
import { httpClient, request } from "@/src/common/services/http.service";

export const fetchMcpTokens = async (): Promise<AdminMcpTokenList> => unwrap(await request(() => httpClient.admin["mcp-tokens"].get()));

export const createMcpToken = async (name: string): Promise<AdminMcpTokenCreated> =>
	unwrap(await request(() => httpClient.admin["mcp-tokens"].post({ name })));

export const revokeMcpToken = async (tokenId: string): Promise<void> => {
	unwrap(await request(() => httpClient.admin["mcp-tokens"]({ tokenId }).delete()));
};
